import { defaultHttpClient } from '../../httpClient';

export const agreeNotificationAlarm = async (code: string) => {
  return defaultHttpClient.request<void>({
    method: 'POST',
    url: `/api/v2/members/me/notification-agreements/`,
    data: { code: code },
  });
};
